export const ARG_TYPES = {
  ACTION: 'ACTION',
  ARG_0_TYPE: 'ARG_0_TYPE',
  BOOLEAN: 'BOOLEAN',
  BUNDLE: 'BUNDLE',
  BI_KEY: 'BI_KEY',
  BIKV_KEY: 'BIKV_KEY',
  BO_KEY: 'BO_KEY',
  BOKV_KEY: 'BOKV_KEY',
  BUNDLE_INPUT_KEY_VALUE: 'BUNDLE_INPUT_KEY_VALUE',
  CONDITION: 'CONDITION',
  EVENT: 'EVENT',
  FIXTURE_INPUT: 'FIXTURE_INPUT',
  FIXTURE_OUTPUT: 'FIXTURE_OUTPUT',
  FIXTURE_SERVO: 'FIXTURE_SERVO',
  INTEGER: 'INTEGER',
  INTEGER_COMPARATOR: 'INTEGER_COMPARATOR',
  INTEGER_ARITHMETIC_OPERATOR: 'INTEGER_ARITHMETIC_OPERATOR',
  LANGUAGE: 'LANGUAGE',
  PAD_INPUT_BUTTON: 'PAD_INPUT_BUTTON',
  PAD_INPUT_CHECKBOX: 'PAD_INPUT_CHECKBOX',
  PERIODIC: 'PERIODIC',
  PLAY_OPERATION: 'PLAY_OPERATION',
  PLAYLIST: 'PLAYLIST',
  PIN_OUTPUT: 'PIN_OUTPUT',
  SFX: 'SFX',
  STRING: 'STRING',
  STATUS: 'STATUS',
  TIMER: 'TIMER',
  VARIABLE: 'VARIABLE',
  VIDEO: 'VIDEO',
}